import get from 'lodash.get';

import {
    getHexColor,
    type MappedProductVariant,
    type UniqueVariants,
    type VariantValue,
} from '@libs/algolia';

type GetPersonalization = (
    personalization: MappedProductVariant['personalization'],
    key: string,
    modifier?: (option: string) => Partial<VariantValue>
) => VariantValue[] | null;

enum MappingPersonalizationKeys {
    FONT_FACE = 'fontFaceOptions',
    THREAD_COLORS = 'styleOptions.threadColors',
}

const mapPersonalizationArray: GetPersonalization = (
    personalization,
    key,
    modifier
) => {
    const options = get(personalization, key);

    if (!options) {
        return null;
    }

    if (options instanceof Array) {
        const result: VariantValue[] = [];

        options.forEach(option => {
            result.push({
                key: option,
                value: option,
                display: option,
                ...modifier?.(option),
            });
        });

        return result;
    }

    return null;
};

// TODO: extend the mapping with other personalization types once we have a more stable data sample.
const keysMapping: {
    key: MappingPersonalizationKeys;
    getMapping: GetPersonalization;
}[] = [
    {
        key: MappingPersonalizationKeys.FONT_FACE,
        getMapping: mapPersonalizationArray,
    },
    {
        key: MappingPersonalizationKeys.THREAD_COLORS,
        getMapping: (personalization, key) =>
            mapPersonalizationArray(personalization, key, option => ({
                value: getHexColor(option),
            })),
    },
];

export const getProductPersonalizations = (product: MappedProductVariant) => {
    const productPersonalizations = {} as UniqueVariants;

    if (product?.personalization) {
        keysMapping.forEach(({ key, getMapping }) => {
            const mappedPersonalization = getMapping(
                product.personalization,
                key
            );

            if (mappedPersonalization && mappedPersonalization.length > 0) {
                productPersonalizations[key] = mappedPersonalization;
            }
        });
    }

    return productPersonalizations;
};
